import { api } from "../api";
import { createApiHook } from "../utils";

export const useGames = createApiHook((year: string) => api.listGames(year));
